import { ApiAccount, ApiExternalOutgoingTransferIntentResponse, ApiMoney } from '../../../openapi';

export function calculateDefaultAccountId({
  currency,
  accounts,
  defaultAccountId,
}: {
  currency: string;
  accounts: ApiAccount[];
  defaultAccountId: string | undefined;
}) {
  let account: ApiAccount | undefined;
  // check if account is in search params
  if (defaultAccountId) {
    account = accounts.find(({ id }) => id === defaultAccountId);
  }
  // check if account with same currency is available
  if (!account) {
    account = accounts.find(({ balance }) => balance.amount > 0 && balance.currency === currency);
  }
  // check if account with same currency is available
  if (!account) {
    account = accounts.find(({ balance }) => balance.amount > 0);
  }
  // fallback to first account
  if (!account) {
    account = accounts[0];
  }

  return account?.id;
}

export function isBalanceSufficientForExternal({
  intent,
  accounts,
  accountId,
}: {
  intent: ApiExternalOutgoingTransferIntentResponse;
  accounts: ApiAccount[];
  accountId: string;
}) {
  const account = accounts.find((a) => a.id === accountId);
  if (!account) return false;
  const debitAmount =
    intent.quote.fx?.side === 'SELL' ? intent.quote.targetAmount.amount : intent.amount.amount;
  return debitAmount <= account.balance.amount;
}

export function isBalanceSufficientForInternal({
  amount,
  accounts,
  accountId,
}: {
  amount: ApiMoney;
  accounts: ApiAccount[];
  accountId: string;
}) {
  const account = accounts.find((a) => a.id === accountId);
  if (!account) return false;
  return amount.amount <= account.balance.amount;
}
